/**
 * smooth-scroll
 * data-smooth-scroll="スクロール先の要素のID"
 */
(() => {
  const offset = 0; // ヘッダの高さ
  document.querySelectorAll("[data-smooth-scroll]").forEach((element) => {
    element.addEventListener("click", (event) => {
      event.preventDefault();
      const target_id = event.target
        .closest("[data-smooth-scroll]")
        .getAttribute("data-smooth-scroll");
      const target = document.getElementById(target_id);
      const rect = target.getBoundingClientRect();

      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const position = rect.top + scrollTop - offset;

      window.scrollTo({
        top: rect.top,
        behavior: "smooth",
      });
    });
  });
})();
